import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { VueRouter } from '../../../models/VueRouter';
import { debug } from 'util';

const state = {
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  addRow(state) {
    let item = new VueRouter();
    state.rows.push(item);
    return state.rows.indexOf(item);
  },
  clearRows(state) {
    state.rows.length = 0;
    state.rows.push(new VueRouter());
    state.message = new httpError();
  },
  removeRoute(state, routeID) {
    if (state.rows.length > 0) {
      for (var index = state.rows.length; index--; ) {
        if (state.rows[index].id === routeID) {
          state.rows.splice(index, 1);
        }
      }
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setRows(state, term) {
    state.rows.length = 0;
    state.rows = term;
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('clearRows');
  },
  getRoutes({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('vue/GetVueRoutes/');
      response
        .then(function (data) {
          if (data.status === 200) {
            commit('setRows', data.data);
            dispatch(
              'setMessage',
              new httpError({ message: 'Retrieved OK', httpStatus: 200 })
            );
          }
          resolve(data.data);
          return;
        })
        .catch(function (err) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error' + err.message, httpStatus: 500 })
          );
          if (err.response.status == 401) {
            reject(401);
          }
          reject(err.response.status);
        });
    });
  },

  updateRoute({ dispatch, state }, rowIndex) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('vue/UpdateVueRoute', state.rows[rowIndex]);
      response
        .then((data) => {
          if (data.status == 200) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  async removeRoute({ commit }, routeID) {
    commit('removeRoute', routeID);

    try {
      var result = await HTTP.delete('vue/DeleteVueRoute/' + routeID);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
